import { Component } from '@angular/core';
import { NavController, Events } from 'ionic-angular';

// Providers
import { ProvidersService } from '../../providers/providers/providers-service';
import { InstructorsService } from '../../providers/instructors/instructors-service';

// Pages
import { InstructorAddEditPage } from '../instructors/instructor-add-edit';

// Helpers
import { HelperCsvService } from '../../providers/helpers/helper-csv-service';

@Component({
  selector: 'page-report-instructors-employer',
  templateUrl: 'report.instructors-employer.html'
})
export class ReportInstructorsEmployerPage {
  headerData: any;
  providers:any = [];
  instructors:any = [];
  selectedProvider:any = {};
  gotRecords:boolean = false;

  constructor(
    public navCtrl: NavController,
    public events: Events,
    public providersService: ProvidersService,
    public instructorsService: InstructorsService,
    public helperCsvService: HelperCsvService
  ) {
    this.headerData = { title: 'Instructors by Employer' };
    this.getProviders();
  }

  getProviders()
  {
    this.providersService.getProviders()
      .subscribe( data => {
        this.providers = data;
      });
  }

  createReport()
  {
    this.instructorsService.getInstructorsByEmployer( this.selectedProvider.provider_id )
      .subscribe( data => {
        this.instructors = data;
        if ( this.instructors.length > 0 )
        {
          this.gotRecords = true;
        }
      });
  }

  setSelectedProvider( provider )
  {
    this.selectedProvider = provider;
  }

  showInstructorAddEditPage( instructor = null )
  {
    this.navCtrl.push( InstructorAddEditPage, {
      instructor: instructor
    });
  }

  createReportCSV()
  {
    this.helperCsvService.exportInstructorList( this.instructors, 'Instructors Employer List ' + this.selectedProvider.provider_name + '.csv' );
  }
}


// WEBPACK FOOTER //
// ./src/pages/reports/report.instructors-employer.ts